import { render, staticRenderFns } from "./EducationalJoiningApplicationTabs.vue?vue&type=template&id=12e06a1c&"
import script from "./EducationalJoiningApplicationTabs.vue?vue&type=script&lang=js&"
export * from "./EducationalJoiningApplicationTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports